import { ServiceForm } from "./service-form";
import { EntityListTitleBar } from "../shared";

export const CreateService = () => (
  <>
    <EntityListTitleBar title={"Create Service"} />
    <ServiceForm id={null} />
  </>
)
